import { render, staticRenderFns } from "./CorporationDivisionTable.vue?vue&type=template&id=19faff7f&scoped=true"
import script from "./CorporationDivisionTable.vue?vue&type=script&lang=js"
export * from "./CorporationDivisionTable.vue?vue&type=script&lang=js"
import style0 from "./CorporationDivisionTable.vue?vue&type=style&index=0&id=19faff7f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19faff7f",
  null
  
)

export default component.exports